import type CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import type { PriceRecommendationState } from '@app/model/market_state/PriceRecommendationState';
import type MarketStateDailySnapshotState from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/MarketStateDailySnapshotState';
import { findDateRowRecommendation, findValidRecommendationStates } from '../../../_table/fragment/MarketStateSnapshotDateBasedTableRowFragment.utilities';

// Reuse the date-table selection, including freshness and rights. A submitted fallback stays selected.
export const findOtherRoomTypeRecommendation = (
	dailySnapshotState: MarketStateDailySnapshotState,
	companyHotel: CompanyHotel,
	canViewRecommendations: boolean,
	today?: string
): PriceRecommendationState | undefined => {
	if (!companyHotel.settings.calendar.showOtherRoomTypeRecommendation) return undefined;
	const snapshot = dailySnapshotState.marketStateDailySnapshot;
	if (snapshot === undefined || snapshot.priceRecommendationStateSnapshot) return undefined;
	const selection = findDateRowRecommendation(dailySnapshotState,
		findValidRecommendationStates(dailySnapshotState, companyHotel, canViewRecommendations, today));
	return selection?.showRecommendedPrice === false ? selection.recommendation : undefined;
};

// A submitted * day shows the Submitted tick in place of its tag, as a normal submitted day.
export const isSubmittedRecommendation = (
	dailySnapshotState: MarketStateDailySnapshotState,
	recommendation: PriceRecommendationState | undefined
): boolean => recommendation !== undefined
	&& (dailySnapshotState.marketStateDailySnapshot?.submittedRecommendationStateIds ?? []).includes(recommendation.id);
